import ApplicationController from '../../../../javascript/controllers/application_controller'

const HIDDEN_BELOW_LG = 'max-lg:hidden'

/**
 * Opens the publication filter sidebar as a modal drawer below the `lg` breakpoint.
 *
 * Toggles `max-lg:hidden`, so the static desktop sidebar never hides, and marks
 * the drawer as a modal dialog only while it is open.
 */
export default class extends ApplicationController {
  static targets = ['drawer']

  toggle() {
    if (this.drawerTarget.classList.contains(HIDDEN_BELOW_LG)) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.drawerTarget.classList.remove(HIDDEN_BELOW_LG)
    this.drawerTarget.setAttribute('role', 'dialog')
    this.drawerTarget.setAttribute('aria-modal', 'true')
    this.addBreadcrumb('UI', 'filter_drawer_opened')
  }

  hide() {
    this.drawerTarget.classList.add(HIDDEN_BELOW_LG)
    this.drawerTarget.removeAttribute('role')
    this.drawerTarget.removeAttribute('aria-modal')
  }
}
